export const ADMIN = '51142f47-cb9a-4262-8c90-d9b9d76b5aaf';
export const ESTERNO = 'ee593d72-7588-4a94-9df8-a8a41e1d36f1';
export const INSEGNANTE = '9578dbfc-fc91-4bde-ab84-74ba4eb3abde';
export const STUDENTE = 'e2165451-0b75-487c-a092-f04e12fcfc67';
